import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const takeWhile = (source, predicate) => {
    const generator = async () => {
        const values = await source.toArray();
        const results = new Array();
        if (predicate.length === 1) {
            for (const value of values) {
                if (predicate(value) === true) {
                    results.push(value);
                }
                else {
                    break;
                }
            }
        }
        else {
            for (let i = 0; i < values.length; i++) {
                const value = values[i];
                if (predicate(value, i) === true) {
                    results.push(value);
                }
                else {
                    break;
                }
            }
        }
        return results;
    };
    return new BasicParallelEnumerable({
        generator,
        type: 0,
    });
};
